<template>
  <div>
    <div class="input-box">
      <div class="input-container">
        <!-- 指令列表 -->
        <!-- <DirectList
          ref="directList"
          @selectDirect="selectDirect"
          @addDirect="addDirect"
          :applyType="AITypeVal"
        ></DirectList> -->
        <!-- 选中指令 -->
        <!-- <UsedDirect
          ref="usedDirect"
          :info="usedDirectInfo"
          @myDirect="toggleDirectsV(true)"
        ></UsedDirect> -->
        
        <!-- @input="inputChange" 唤起指令↓ -->
        <el-input
          ref="textInput"
          v-model="prompt"
          @keydown.native="inputKeyDown"
          autofocus
          type="textarea"
          :rows="3"
          :placeholder="AITypeVal!==2? '按 Enter 键发送消息，使用 Ctrl + Enter 换行' : '或者输入在线文件的链接地址'"
        />

        <div class="bottom-handles rf ac jsb">
          <!-- 大模型会话下才有 -->
          <div class="model-types" v-if="AITypeVal ==0">
            <!-- 选择模型 -->
            <el-select
              v-model="modelName"
              placeholder="请选择模型"
              size="small"
              style="width: 145px; margin-right: 5px;"
            >
              <el-option
                v-for="(item, index) in modelList"
                :key="index"
                :label="item.value"
                :value="item.value"
              />
            </el-select>
            <!-- 是否联网 -->
            <el-tooltip
              :content="isInternet? '已开启+所选模型+互联网访问权限' : '已关闭+所选模型+互联网访问权限'"
              placement="top"
            >
              <el-switch
                v-model="isInternet"
                inline-prompt
                active-text="联网"
                inactive-text="未联网"
                :width="60"
              />
            </el-tooltip>
          </div>
          <!-- OCR识别下才有 -->
          <div class="model-types" v-if="AITypeVal ==2">
            <!-- 选择服务 -->
            <el-select
              v-model="serviceName"
              placeholder="请选择服务"
              @change="serviceConfirm"
              size="small"
              style="width: 145px; margin-right: 5px;"
            >
              <el-option
                v-for="(item, index) in serviceList"
                :key="index"
                :label="item.value"
                :value="item.value"
              />
            </el-select>
          </div>
          
          <div class="right-box rf ac">
            <!-- 非大模型会话 才有上传文件功能 -->
            <span
              class="upload-btn"
              v-if="[1,2,3,4].includes(AITypeVal)"
            >
              <el-button
                size="small"
                plain
                @click="uploadHandle"
                :disabled='!canSend'
              >
                <i class="el-icon-upload2"></i>
                <small class="txt">文件上传</small>
              </el-button>
            </span>
            <span class="send-btn">
              <el-button @click="sendMessage" :disabled='!canSend'>
                <i class="el-icon-s-promotion"></i>
              </el-button>
            </span>
          </div>
        </div>
      </div>
    </div>

    <UploadFile
      :limit="1"
      :draggable="importInfo.draggable"
      :accept="importInfo.accept"
      :title="'文件上传'"
      :size="importInfo.size"
      :url="importInfo.url"
      :dialogVisible.sync="importInfo.dialogVisible"
      :extra="importInfo.extra"
      v-if="importInfo.dialogVisible"
      @fileSuccess="uploadSuccessHandle"
    >
      <div slot="des">
        <div v-if="AITypeVal === 2" style="padding-bottom: 12px;">
          <!-- HUAWEI_OCR_API服务下，可选择方案；LLM_Qwen_VL服务下，ocrType只有‘aiOcr’ -->
          <template v-if="serviceName=='HUAWEI_OCR_API'">
            <span>识别方案选择:  </span> 
            <el-select
              v-model="ocrType"
              style="width: 400px"
            >
              <el-option
                v-for="item in ocrTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <div style="height:8px"></div>
          </template>
          <span>选择PDF文件要处理的页码范围:  </span>  
          <el-input-number style="width: 80px;" :min="1" :max="endPage || 9999" :controls="false" v-model="startPage" placeholder="起始页"/> ~
          <el-input-number style="width: 80px;" :min="startPage || 1" :max="9999" :controls="false" v-model="endPage" placeholder="结束页"/>
        </div>
      </div>
    </UploadFile>

    <!-- 新建指令弹窗 -->
    <!-- <AddDirect
      v-if="addDirectV"
      :visible="addDirectV"
      @toggleVisible="toggleAddDirectV"
      @addSuccess="addDirectSuccess"
    >
    </AddDirect> -->
  </div>
</template>

<script>
import UploadFile from '@/components/uploadFile/upload.vue';
// import AddDirect from "./Direct/AddDirect.vue";
// import DirectList from "./Direct/DirectList.vue";
// import UsedDirect from "./Direct/UsedDirect.vue";
import { EventBus } from '@/utils/event-bus.js';

export default {
  name: 'ChatInput',
  components: {
    UploadFile,
    // DirectList,
    // AddDirect,
    // UsedDirect
  },
  props: {
    AITypeVal: {
      type: Number
    },
    canSend: {
      type: Boolean
    },
    sessionId: {
      type: String
    }
  },
  watch: {
    sessionId (newVal, oldVal) {
      //存储此前编辑框未发出的内容
      if(oldVal) {
        this.changeData(oldVal)
      }

      this.$nextTick(()=>{
        // 页面数据切换，清除前一页指令相关内容
        // this.hideAboutDirect();

        // 页面切换，刷新ocrType等数据
        if(this.serviceName=='HUAWEI_OCR_API') {
          this.initOcrType()
        } else {
          this.startPage = 1
          this.endPage = 1
          this.ocrType = 'aiOcr'
        }

        // 清空上一个会话框编辑内容
        this.prompt = ''

        // 写入此前存储的 编辑框未发出的内容
        if(oldVal && newVal) {
          this.appendData(newVal)
        }
      })
    }
  },
  data () {
    const _this = this
    return {
      importInfo: {
        dialogVisible: false,
        draggable: true,
        accept: (_this.AITypeVal===1 || _this.AITypeVal===3) ? ".xls,.xlsx"
              : _this.AITypeVal===2 ? ".png,.jpg,.jpeg,.pdf"
              : _this.AITypeVal===4 ? ".png,.jpg,.jpeg"
              : '',
        size: (_this.AITypeVal===1 || _this.AITypeVal===3) ? 5
            : _this.AITypeVal===2 ? 7
            : _this.AITypeVal===4 ? 10
            : 100,
        url:
          window.SITE_CONFIG.apiURL +
          '/front/fileupload/alioss/upload'
      },
      prompt: '', //输入框

      // 识别方案
      ocrTypeList: [
        { label: '智能分类识别（普通图片、发票和行程单类文件适用）', value: 'ocrAutoClassification' },
        { label: '智能文档解析（合同PDF文件、复杂表格图像、手写体等使用）', value: 'ocrSmartDocumentRecognizer' },
      ],
      startPage: 1,
      endPage: 1,
      ocrType: 'ocrAutoClassification',

      // 选择模型
      modelList: [
        ...window.SITE_CONFIG.dictList.AI_MODEL_NAME
      ],
      modelName: [
        ...window.SITE_CONFIG.dictList.AI_MODEL_NAME
      ][0].value, //第一项为默认项
      isInternet: false, //是否联网
      // 选择服务
      serviceList: [
        {value: 'HUAWEI_OCR_API'},
        {value: 'LLM_Qwen_VL'}
      ],
      serviceName: 'HUAWEI_OCR_API', //默认

      // 提示词/指令
      usedDirectInfo: null,
      addDirectV: false, //新建指令弹窗
    }
  },
  methods: {
    uploadHandle() {
      this.importInfo.dialogVisible = true
    },
    uploadSuccessHandle(flag, res) {
      const data = res.data
      if (data.aliOssId) {
        // this.fileAliOssObj = data
        // this.sendMessage()
        this.$emit('uploadSuccessHandle',data)
      }
    },

    serviceConfirm(val) {
      // console.log(val)
      if(val=='HUAWEI_OCR_API') {
        this.initOcrType()
      } else {
        this.startPage = 1
        this.endPage = 1
        this.ocrType = 'aiOcr'
      }
    },
    initOcrType() {
      this.startPage = 1
      this.endPage = 1
      this.ocrType = 'ocrAutoClassification'
    },

    // 输入框输入事件处理
    // inputChange(e) {
    //   if(this.prompt.startsWith('/')) {
    //     // 若输入/开头：弹窗-指令选择列表
    //     const directText = this.prompt.replace(/^\/+/, ''); // 搜索字段：去除开头的/
    //     this.showAFilterDirects(directText)
    //   } else {
    //     // 非/开头，则关闭弹窗
    //     this.toggleDirectsV(false)
    //   }
    // },
    inputKeyDown (e) {
      if(this.AITypeVal!==2){
        if (e.keyCode === 13) {
          if (e.ctrlKey) { // Ctrl + Enter 换行
            this.prompt += "\n";
            return;
          }
          e.preventDefault();
          this.$emit('update:prompt',this.prompt) //修改父组件的prompt值（v-model:prompt="prompt"绑定）
          let emitParams = {}
          if(this.usedDirectInfo && this.usedDirectInfo.promptId) {
            // 使用了指令
            emitParams['promptId'] = this.usedDirectInfo.promptId
          }
          if(this.AITypeVal==0) {
            // 大模型会话
            emitParams['modelName'] = this.modelName;
            emitParams['isInternet'] = this.isInternet;
          }
          this.$emit('inputSendMessage', emitParams);
          // this.hideAboutDirect();
          //清除存储的数据
          this.clearUnsenData();
        }
      } else { //OCR识别
        if (e.keyCode === 13) {
          e.preventDefault();
          if(isUrl(this.prompt)){//输入是URL
            this.$emit('update:prompt',this.prompt)
            let emitParams = {}
            if(this.usedDirectInfo && this.usedDirectInfo.promptId) {
              // 使用了指令
              emitParams['promptId'] = this.usedDirectInfo.promptId
            }
            this.$emit('inputSendMessage', emitParams);
            // this.hideAboutDirect();
            //清除存储的数据
            this.clearUnsenData();
          } else {
            ElMessage.error("请输入正确的在线文件链接地址！");
            return
          }
        }
      }
    },
    isUrl(str) {
      const pattern = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
      return pattern.test(str);
    },
    sendMessage() {
      this.$emit('update:prompt',this.prompt)
      let emitParams = {}
      if(this.usedDirectInfo && this.usedDirectInfo.promptId) {
        // 使用了指令
        emitParams['promptId'] = this.usedDirectInfo.promptId
      }
      if(this.AITypeVal==0) {
        // 大模型会话
        emitParams['modelName'] = this.modelName;
        emitParams['isInternet'] = this.isInternet;
      }
      this.$emit('inputSendMessage', emitParams);
      // this.hideAboutDirect();
      //清除存储的数据
      this.clearUnsenData();
    },

    // 提示词/指令相关S↓↓↓
    toggleDirectsV(flag) {
      this.$refs.directList.toggleDirectsV(flag)
    },
    // 根据/后的内容筛选指令
    showAFilterDirects(text) {
      this.$refs.directList.toggleDirectsV(true)
      this.$refs.directList.filterDirects(text)
    },
    // 选中指令
    selectDirect(info) {
      // 插入指令内容
      this.prompt = info.promptContent;
      this.$refs.textInput.focus(); //聚焦
      // 展示选中的指令信息
      this.usedDirectInfo = info;
      this.$refs.usedDirect.toggleDirectV(true);
    },
    hideAboutDirect() {
      this.$refs.directList.toggleDirectsV(false)
      this.$refs.usedDirect.toggleDirectV(false)
      this.usedDirectInfo = {}
      this.prompt = ''
    },
    handleClick() {},
    // 新建指令
    addDirect() {
      this.addDirectV = true
    },
    toggleAddDirectV(flag) {
      this.addDirectV = flag
    },
    addDirectSuccess() {
      this.addDirectV = false;
      // 刷新指令列表
      this.$refs.directList.filterDirects('')
    },
    // 提示词/指令相关E↑↑↑

    // 存储编辑框未发送内容S↓↓↓
    changeData(id) {
      //存储此前编辑框未发出的内容
      if(!id) return
      if(!this.prompt) {
        this.clearUnsenData(id);
        return
      }
      this.$store.dispatch('changeChatHomeData', {
        id, 
        val: {
          prompt: this.prompt,
          //指令信息
          usedDirectInfo: this.usedDirectInfo && this.usedDirectInfo.promptId
                          ? this.usedDirectInfo : null
        }
      });
    },
    appendData(id) {
      // 写入此前存储的 编辑框未发出的内容
      if(!id) return
      const contents = this.$store.getters.getChatHomeData(id);
      if(!contents || !contents.prompt) return;
      this.prompt = contents.prompt;
      this.$refs.textInput.focus(); //聚焦
      // 指令信息回显
      if(contents.usedDirectInfo) {
        this.usedDirectInfo = contents.usedDirectInfo;
        this.$refs.usedDirect.toggleDirectV(true);
      }
    },
    clearUnsenData(id=this.sessionId) { //未传id时默认sessionId
      //清除此前存储的 编辑框未发出的内容
      this.$store.dispatch('removeChatHomeData', id);
    },
    // 存储编辑框未发送内容E↑↑↑
  },
  mounted () {
    EventBus.$on('autoSendPrompt', info => {
      this.$nextTick(()=>{
        this.selectDirect(info)
        this.sendMessage()
      })
    })

    this.$nextTick(()=>{
      this.appendData(this.sessionId)
    })

    // 监听浏览器刷新或关闭
    window.addEventListener('beforeunload', () => {
      this.changeData(this.sessionId)
    })
  },
  beforeDestroy() {
    this.changeData(this.sessionId)

    EventBus.$off('autoSendPrompt')
  }
}
</script>

<style scoped lang="scss">
  .input-box {
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    // align-items: center;
    flex-direction: row;
    // box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
    // padding: 15px;
    // margin: auto 150px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    border-radius: 8px;

    .add-file{
      width: 22px;
      height: 22px;
    }

    .input-container {
      width: 100%;
      // margin: 0;
      // border: none;
      // padding-top: 6px;
      // display: flex;
      // justify-content:center;
      position: relative;
      border-radius: 8px;
      // 增加鼠标移入效果
      border: 1px solid transparent;
      &:hover{
        border: 1px solid var(--color-primary);
      }

      // .input-btn{
      //   position: absolute;
      //   top: 10px;
      //   left: 10px;
      //   z-index: 99;
      //   margin-right: 10px;
      //   ::v-deep .el-button{
      //     border-radius: 10px;
      //     width:50px;
      //     height: 50px;
      //     >span{
      //       display: flex !important;
      //       flex-direction: column !important;
      //       font-size: 14px;
      //       .txt{
      //         margin-top: 5px;
      //         font-size: 10px;
      //       }
      //     }
      //   }
      // }
      ::v-deep .el-textarea {
        --el-input-border-color: transparent;
        .el-textarea__inner,
        &>textarea{
          max-height: 73px;
          border-radius: 8px;
          resize: none !important; // 去除右下角图标
          border: none !important;
          // 去除原来的鼠标移入及聚焦样式
          &:focus,
          &:hover{
            box-shadow: none !important;
          }
        }
        &.inner-pl{
          .el-textarea__inner{
            padding-left: 70px;
          }
        }
      }
      

      // ::v-deep .el-textarea__inner {
      //   outline: none;
      //   border: none;
      //   resize: none;
      //   box-shadow: none;
      //   padding: 0;
      //   height: 100%;
      // }

      // .el-textarea {

      //   .el-textarea__inner::-webkit-scrollbar {
      //     width: 0;
      //     height: 0;
      //   }
      // }

      .select-file {
        position: absolute;
        right: 48px;
        top: 20px;
      }

      .right-box {
        margin-left: auto; //始终居右
        .upload-btn{
          margin-right: 14px;
          ::v-deep .el-button{
            border-radius: 8px;
            width: 84px;
            height: 32px;
            padding: 0;
            >span{
              font-size: 14px;
              .txt{
                margin-left: 5px;
                font-size: 12px;
              }
            }
          }
        }
      }

      .send-btn {
        ::v-deep .el-button {
          padding: 5px;
          border-radius: 6px;
          color: #ffffff;
          background: var(--gradient-BtnBg);
          box-shadow: var(--gradient-BoxShadow);
          border-color: transparent;
          font-size: 20px;
        }
        .el-button.is-disabled, .el-button.is-disabled:hover, .el-button.is-disabled:focus{
          color: var(--el-button-disabled-text-color);
          background: var(--el-button-disabled-bg-color);
          border-color: var(--el-button-disabled-border-color);
        }
      }
      // .send-btn-abs {
      //   position: absolute;
      //   right: 12px;
      //   bottom: 10px;
      // }

      .bottom-handles {
        padding: 8px 11px;
      }
    }
  }
</style>